export default {"src":"/_next/static/image/public/images/flags/flag_371.332db1e78b0fb1d89b1b744952c81787.svg","height":16,"width":24};